<div class="dropdown-container" [class.disabled]="disabled">
  <label *ngIf="label" class="dropdown-label">{{ label }}</label>

  <div class="dropdown-display" (click)="toggleDropdown()">
    <span class="dropdown-text">
      {{ value || placeholder }}
    </span>
    <span class="dropdown-arrow" [class.open]="isOpen">▼</span>
  </div>

  <ul class="dropdown-list" *ngIf="isOpen">
    <li
      *ngFor="let option of options"
      (click)="selectOption(option)"
      [class.selected]="option === value"
    >
      {{ option.toLowerCase().replaceAll('_', ' ') }}
    </li>
  </ul>
</div>
